export default "__VITE_ASSET__m0WcqbsA__"